import { ZfBanner, ZfIcon, ZfPopover, ZfPopoverHeader, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '../../api';
import { useYwuApp } from '../../contexts/ywu-app-context';
import { isCrossBorderClient } from '../../utils/crossBorderUtils';
import { CrossBorderWarningMessage } from './CrossBorderWarningMessage';

interface ICrossBorderWarningProps {
    variant: 'banner' | 'popover';
}

export const CrossBorderWarning: FunctionComponent<ICrossBorderWarningProps> = ({ variant }) => {
    const { t } = useTranslation();
    const { isPresentationMode } = useYwuApp();
    const { data: client } = useClient();
    const showCrossBorderBanner = !isPresentationMode && client && isCrossBorderClient(client);

    if (!showCrossBorderBanner) return null;

    if (variant === 'banner')
        return (
            <ZfBanner type="warning" titleText={t('crossBorderWarningTitle')}>
                <ZfTypography variant="body-small">
                    <CrossBorderWarningMessage />
                </ZfTypography>
            </ZfBanner>
        );

    return (
        <ZfPopover side="bottom" alignment="start" style={{ display: 'inline-flex' }}>
            <ZfIcon slot="anchor" name="warning" size="large" style={{ color: 'var(--fg-color-warning-normal)', cursor: 'pointer' }} />
            <ZfPopoverHeader>{t('crossBorderWarningTitle')}</ZfPopoverHeader>
            <ZfTypography variant="label-extra-small" color="normal">
                <CrossBorderWarningMessage />
            </ZfTypography>
        </ZfPopover>
    );
};
